import {
  MyAccountTheme,
  MyInsuranceFormSubmitButtonClasses,
} from '@dxp-module/themes'
import { makeStyles } from '@mui/styles'

const submitButtonStyles = makeStyles<
  MyAccountTheme,
  object,
  MyInsuranceFormSubmitButtonClasses
>(
  ({ palette, breakpoints }) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      margin: '15px 0 0 0',
    },
    button: {
      padding: 7,
      borderRadius: 0,
      marginBottom: 15,
      border: `1px solid ${palette.primary.main}`,
      '&:hover': {
        backgroundColor: palette.primary.main,
      },
      [breakpoints.down('sm')]: {
        width: '100%',
        maxWidth: 'unset',
      },
    },
    caption: {
      backgroundColor: 'transparent',
    },
    disabled: {
      cursor: 'not-allowed',
      border: `1px solid ${palette.grey[400]}`,
      backgroundColor: palette.grey[50],
    },
    loader: {
      margin: '0 5px',
      color: palette.common.white,
    },
  }),
  { name: 'Insurance_Form_Submit_Button' }
)

export default submitButtonStyles
